/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeviceDto } from '../../models/device-dto';

export interface DeviceControllerFindAll$Params {
}

export function deviceControllerFindAll(http: HttpClient, rootUrl: string, params?: DeviceControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DeviceDto>>> {
  const rb = new RequestBuilder(rootUrl, deviceControllerFindAll.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DeviceDto>>;
    })
  );
}

deviceControllerFindAll.PATH = '/api/device';
